import Icon, { DownOutlined, SearchOutlined } from '@ant-design/icons';
import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { SelectAll } from '../../../_config/constants/select-all.constant';
import { GetAllPharmacies } from '../../../_config/utils/get-all-pharmacies.util';
import CustomDropdown from '../../../v2-components/Antd/Dropdown';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import Pharmacies from '../../../v2-components/Pharmacies';
import { STATUSADAPTER } from './constants/status-adapter.constant';
import { TYPE_ADAPTER } from './constants/type-adapter.constant';
import { mapOptions } from './handle/map-options.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tab-options.handle';
import { unixAdapter } from './handle/unix-adapter.handle';
import { Service } from './service/index';
import Loading from '../../../v2-components/Loading';
import { handleNotificationClick } from '../../../_config/functions/check-notification-and-mark-as-read';
import './style.scss';

export default function AdminClaimsListPage() {
	const { t } = useTranslation('global');
	const [data, setData] = useState();
	const [paginationResponse, setPaginationResponse] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location?.search);
	const page = searchParams.get('page');
	const statusQueryParam = searchParams.get('status');
	const rutQueryParam = searchParams.get('rut');
	const claimIdQueryParam = searchParams.get('claim-id');
	const pharmacyQueryParam = searchParams.get('pharmacy');
	const [status, setStatus] = useState(statusQueryParam);
	const [rut, setRut] = useState(rutQueryParam);
	const [rutSearchText, setRutSearchText] = useState('');
	const [claimIdSearchText, setClaimIdSearchText] = useState('');
	const [pharmacy, setPharmacy] = useState(pharmacyQueryParam);
	const [claimId, setClaimId] = useState(claimIdQueryParam);
	const [claimType, setClaimType] = useState(null);
	const [options, setOptions] = useState();

	const rowKey = '_id';

	useEffect(() => {
		Promise.all([new Service().getClaims({ status, page, pharmacy, rut, claimId, claimType }), new Service().getPharmacies()])
			.then(([claimsData, pharmaciesData]) => {
				console.log('claimsData', claimsData);
				setData(claimsData.data);
				setPaginationResponse(claimsData);
				setIsLoading(false);
				setOptions([SelectAll[Enviroment.LANGUAGE], ...mapOptions(pharmaciesData?.data)]);
			})
			.catch((error) => {
				console.log(error);
			});
	}, [status, page, pharmacy, rut, claimId, claimType]);

	const handlePageChange = (page) => {
		searchParams.set('page', page);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleStatusQueryChange = (status) => {
		searchParams.set('status', status);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleRutChange = (rut) => {
		searchParams.set('rut', rut);
		setRut(rut);
		if (!rut) {
			searchParams.delete('rut');
			setRut(null);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleClaimIdChange = (claimId) => {
		searchParams.set('claim-id', claimId);
		setClaimId(claimId);
		if (!claimId) {
			searchParams.delete('claim-id');
			setClaimId(null);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleSearchRut = (e) => {
		setRutSearchText(e.target.value);
	};

	const handleSearchClaimId = (e) => {
		setClaimIdSearchText(e.target.value);
	};

	const onTabChange = () => {
		searchParams.set('page', 1);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleTabClick = (key) => {
		const tab = tabOptions(data).find((tab) => tab.key === key);
		if (tab) {
			setStatus(tab.status);
			handleStatusQueryChange(tab.status);
			onTabChange();
		}
		const filteredData = tabOptions(data).map((tab) => ({
			...tab,
			data: tab?.data?.filter((item) => {
				return item;
			}),
		}));
		return filteredData;
	};

	const handleSelectChange = (value) => {
		GetAllPharmacies(value, setPharmacy);
		searchParams.set('pharmacy', value);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const operations = (
		<div className="own-claim-search-container">
			<CustomSearch
				placeholder={`N° de ${t('tracking.personalId')}`}
				onChange={handleSearchRut}
				onSearch={() => handleRutChange(rutSearchText)}
			/>
			<CustomSearch placeholder={'N° de solicitud'} onChange={handleSearchClaimId} onSearch={() => handleClaimIdChange(claimIdSearchText)} />
		</div>
	);

	const paginationConfig = {
		current: paginationResponse?.currentPage,
		pageSize: paginationResponse?.itemsPerPage,
		total: paginationResponse?.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const initialActiveTab = tabOptions(data).find((tab) => tab.status === status)?.key;

	const items = [
		{
			key: '1',
			label: 'Todas',
			value: 'null',
			onClick: () => setClaimType(null),
		},
		{
			key: '2',
			label: 'Reclamo',
			value: 'claim',
			onClick: () => setClaimType('claim'),
		},
		{
			key: '3',
			label: 'Sugerencia',
			value: 'suggestion',
			onClick: () => setClaimType('suggestion'),
		},
		{
			key: '4',
			label: 'Felicitaciones',
			value: 'congratulations',
			onClick: () => setClaimType('congratulations'),
		},
	];

	const columns = [
		{
			align: 'center',
			title: 'N° solicitud',
			dataIndex: 'claim_id',
			key: 'claim_id',
		},
		{
			align: 'center',
			title: 'N° pedido',
			dataIndex: 'trx_id',
			key: 'trx_id',
			render: (trx_id) => trx_id || '--',
		},
		{
			align: 'center',
			title: 'Farmacia',
			dataIndex: 'pharmacy',
			key: 'pharmacy',
		},
		{
			align: 'center',
			title: (
				<CustomDropdown menu={{ items }} trigger={['click']}>
					<span style={{ cursor: 'pointer' }}>
						Tipo de solicitud <DownOutlined />
					</span>
				</CustomDropdown>
			),
			dataIndex: 'type',
			key: 'type',
			render: (type) => TYPE_ADAPTER[type],
		},
		{
			align: 'center',
			title: `${t('tracking.personalId')} cliente`,
			dataIndex: 'rut',
			key: 'rut',
		},

		{
			align: 'center',
			title: 'Estado',
			dataIndex: 'status',
			key: 'status',
			render: (status) => STATUSADAPTER[status],
		},
		{
			align: 'center',
			title: 'Fecha',
			dataIndex: 'created_at',
			key: 'created_at',
			render: (created_at) => unixAdapter(created_at),
		},
		{
			align: 'center',
			title: 'Detalle',
			dataIndex: 'claim_id',
			key: 'claim_id',
			render: (claim_id, record) => {
				console.log('record', record);
				return (
					<Link to={`/v2/admin-claims/detail/${claim_id}`} onClick={() => handleNotificationClick(record?.claim_id, record?.pharmacy)}>
						<Icon className="link-voucher" component={SearchOutlined} />
					</Link>
				);
			},
		},
	];

	if (isLoading) {
		return <Loading />;
	}

	return (
		<div className="admin-claims-list-container">
			<Row>
				<Col span={8}>
					<h2>Reclamos y sugerencias </h2>
				</Col>
			</Row>
			<Row justify="left">
				<span>Filtrar por:</span>
				<Pharmacies style={{ width: '50%', marginLeft: '10px' }} onChange={handleSelectChange} options={options} />
			</Row>
			<Row>
				<Col span={24}>
					<Col className={'own-main-container'}>
						<CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}>
							{handleTabClick().map((tab) => (
								<CustomTabs key={tab.key} tab={tab.tab}>
									<CustomTable dataSource={tab.data} columns={columns} pagination={paginationConfig} rowKey={rowKey} />
								</CustomTabs>
							))}
						</CustomTabs>
					</Col>
				</Col>
			</Row>
		</div>
	);
}
